import { useMemo } from "react";
import { Controller, useFormContext } from "react-hook-form";
import FileInput from "./FileInput";
import { getDialogProps } from "../../../frontend/components/library/theme";

export default function FileField({
  name,
  label,
  control,
  onDelete,
  variant,
  dialogProps: customDialogProps,
  ...rest
}) {
  const { trigger } = useFormContext();

  const dialogProps = useMemo(() => {
    if (customDialogProps) return customDialogProps;
    if (variant) return getDialogProps(variant);
    return undefined;
  }, [customDialogProps, variant]);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, onChange }, fieldState: { error } }) => {
        const handleChange = (file) => {
          onChange(file);
          trigger(name);
        };

        return (
          <FileInput
            name={name}
            label={label}
            value={value}
            onChange={handleChange}
            error={error?.message}
            onDelete={onDelete}
            dialogProps={dialogProps}
            {...rest}
          />
        );
      }}
    />
  );
}
